import {RouteObject} from 'react-router-dom';
import {ROUTES} from '../../routes';
import {ReviewCreate, ReviewUpdate} from './review-create-update';
import {ReviewListing} from './review-listing';
import {ReviewInbox} from './review-inbox';

export const JobReviewRoutes: RouteObject = {
  path: ROUTES.ADMIN.JOB_REVIEWS.path,
  children: [
    {
      path: ROUTES.ADMIN.JOB_REVIEWS.INDEX.path,
      element: <ReviewListing />,
    },
    {
      path: ROUTES.ADMIN.JOB_REVIEWS.CREATE.path,
      element: <ReviewCreate />,
    },
    {
      path: ROUTES.ADMIN.JOB_REVIEWS.RESPONSE.path,
      element: <ReviewCreate isResponse={true} />,
    },
    {
      path: ROUTES.ADMIN.JOB_REVIEWS.DETAIL.path,
      element: <ReviewUpdate />,
    },
  ],
};

export const ReviewRoutes: RouteObject = {
  path: ROUTES.ADMIN.REVIEWS.path,
  children: [
    {
      path: ROUTES.ADMIN.REVIEWS.INBOX.path,
      element: <ReviewInbox />,
    },
  ],
};
